module.exports = __webpack_public_path__ + "img/tr_p_companies_faq@2x.0c11cc4f.jpg";